import { useTranslation } from 'react-i18next'

/**
 * The "or" rule between a page's password path and its SSO buttons
 * (CR-SSO-INVITE-PX-2026-09-26). Today's `/login` divider, moved verbatim so
 * both pages share one. It renders ONLY inside `SsoButtons`, so it can never
 * sit over zero buttons (AC-8 / AC-11). The label is read aloud, so there is no
 * `role="separator"`; the two rules are decorative.
 */
export function SsoDivider() {
  const { t } = useTranslation('auth')
  return (
    <div className="flex items-center gap-3">
      <span aria-hidden className="h-px flex-1 bg-border" />
      <span className="text-[0.6875rem] uppercase tracking-[0.08em] text-muted-foreground">
        {t('form.divider')}
      </span>
      <span aria-hidden className="h-px flex-1 bg-border" />
    </div>
  )
}
